export default "__VITE_ASSET__CrTCy4wn__"